import { BASE_URL } from "../api";

/**
 * Private dashboard media is limited to the configured Accounts origin.
 * This prevents broad backend serializers from turning the account page into
 * an implicit third-party tracking surface.
 */
export function toTrustedClientMediaUrl(value) {
  const path = typeof value === "string" ? value.trim() : "";
  if (!path || path.startsWith("//")) return "";

  try {
    const trustedBase = new URL(`${String(BASE_URL || "").replace(/\/+$/, "")}/`);
    const resolved = new URL(path, trustedBase);
    if (
      !["http:", "https:"].includes(resolved.protocol) ||
      resolved.origin !== trustedBase.origin ||
      resolved.username ||
      resolved.password
    ) {
      return "";
    }
    return resolved.href;
  } catch (error) {
    return "";
  }
}
